import {
  createMultiStyleConfigHelpers,
  StyleThemingProps,
} from '@chakra-ui/react'
import { sharedComponentColorKeys } from '~/components/shared/componentStyles/_colors'
import { asChakraVariable, themeColorSectionKeys } from '~/themes/colors/colors'
import { textStyleKeys } from '~/themes/textStyles'
import { ZIndex } from '~/types/ThemeTypes'
import {
  createCustomStyleContext,
  useCustomMultiStyleConfig,
} from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

const { Dropdown } = themeColorSectionKeys.shared

const scrollingInputDropdownStyleParts = [
  'container',
  'vstack',
  'dropdownContainer',
  'dropdownItemsWrapper',
  'dropdownItem',
] as const
const configHelper = createMultiStyleConfigHelpers(
  scrollingInputDropdownStyleParts,
)

const { DropdownContainer } = sharedComponentColorKeys.ScrollingInputDropdown

export const ScrollingInputDropdownStyle = configHelper.defineMultiStyleConfig({
  baseStyle: {
    container: {},
    vstack: {
      width: '100%',
      position: 'relative',
      gap: '0.25rem',
    },
    dropdownContainer: {
      width: '100%',
      height: 'auto',
      bg: DropdownContainer.Background,
      zIndex: ZIndex.dropdown,
      borderRadius: '0.375rem',
      border: '1px solid',
      borderColor: DropdownContainer.Border,
      boxShadow: `${asChakraVariable(
        DropdownContainer.BoxShadow,
      )} 0px 0px 2px 2px`,
      pt: 'calc(0.25rem)',
      px: '0.25rem',
      pb: '0.25rem',
      position: 'absolute',
    },
    dropdownItemsWrapper: {
      flexDirection: 'column',
      flex: 1,
      overflow: 'hidden',
      maxHeight: '30vh',
    },
    dropdownItem: {
      flexDirection: 'row',
      flex: 1,
      h: 'auto',
      p: '0px',
      pr: '0.25rem',
      width: '100%',
      bg: Dropdown.Items.Background,
      alignContent: 'center',
      _hover: {
        backgroundColor: Dropdown.Items.Background.Hover,
      },
      _selected: {
        backgroundColor: Dropdown.Items.Background.Selected,
      },
      _active: {
        backgroundColor: Dropdown.Items.Background.Active,
      },
      textStyle: textStyleKeys.Body2,
    },
  },
})

const themeKey = getName({ ScrollingInputDropdownStyle })
export const useScrollingInputDropdownStyle = (props?: StyleThemingProps) => {
  return useCustomMultiStyleConfig<typeof scrollingInputDropdownStyleParts>(
    themeKey,
    props,
  )
}

export const useScrollingInputDropdownStyleConfig = () => {
  createCustomStyleContext<typeof scrollingInputDropdownStyleParts>(themeKey)
}
